<template lang="pug">
.table_dashboard_container(:class="{'table_design': withStyle}")
    vm-table(:multiple="multiple" v-model="selectedRows" :data="data" @input="onSelectRow")
        template(slot="header")
            .flex.center.gap-1.margin-bottom
                input-dashboard(v-if="search" @enter="onSearch" @click-delete="onDeleteSearch")
                vm-order-by.orderBy(v-if="orderBy" :sort-by-text="$t('strings.order_by')" :data="[columns[0],columns[1],columns[2]]" v-model="filters.orderBy" @change="onChangeOrder" :serializer="item => $t('purchase_orders.'+ item)")
                vm-dropdown(v-if="orderBy" ref="dropdown" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="default" icon="funnel-outline")
                    vm-dropdown-menu()
                        .filters.flex-col
                            .flex
                                h4 {{ $t('strings.filters') }}
                                vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                            vm-select(:label="$t('purchase_orders.unit_of_measurement')" multiple v-model="filters.whereIn.unit_of_measurement")
                                vm-select-item(v-for="(filter, index) in typeFilters" :key="index" :value="filter" :text="filter")
                            .flex
                                vm-button(@click="applyFilters") {{ $t('strings.apply') }}
        template(slot="thead")
            vm-th(:key="index" v-if="hasId(column)" v-for="(column, index) in columns")
                span(:class="{'text-center': centerRows}") {{ $t(translations + '.' + column) }}
        template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="hasId(column)" v-for="(column, index) in columns")
                    .row(@click="onClickRow(tr)")
                        span(v-if="column !== 'status'" :class="{'text-center': centerRows, 'green-color': greenText, 'orange-color': orangeText}") {{data[indextr][column]}}
                        vm-status-indicator.status(v-if="column == 'status'" pulse=true type="text" :color="setColor(tr)")
    vm-pagination(v-if="pagination" :total="totalPages" v-model="currentPage" goto)
</template>

<script>
const InputDashboard = () => import('@/components/dashboard/InputDashboard.vue')

export default {
  name: 'TableDashboard',
  components: {
    InputDashboard
  },
  props: {
    selectedRows: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => [{}]
    },
    multiple: {
      type: Boolean,
      default: false
    },
    id: {
      type: Boolean,
      default: false
    },
    orderBy: {
      type: Boolean,
      default: false
    },
    search: {
      type: Boolean,
      default: true
    },
    totalPages: {
      type: Number,
      default: 1
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pagination: {
      type: Boolean,
      default: true
    },
    translations: {
      type: String,
      default: 'strings'
    },
    centerRows: {
      type: Boolean,
      default: false
    },
    orangeText: {
      type: Boolean,
      default: false
    },
    greenText: {
      type: Boolean,
      default: false
    },
    withStyle: {
      type: Boolean,
      default: true
    },
    typeFilters: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      filters: {
        whereIn: {
          unit_of_measurement: []
        },
        orderBy: ''
      }
    }
  },
  watch: {
    date (newDate) {
      this.$emit('loadRecords', 1)
    },
    currentPage (newPage) {
      this.$emit('loadRecords', newPage)
    }
  },
  methods: {
    onDeleteSearch () {
      this.$emit('clickDelete')
    },
    onClickRow (row) {
      this.$emit('clickRow', row)
    },
    onSelectRow () {
      this.$emit('selectRow')
    },
    onSearch (input) {
      this.$emit('search', input)
    },
    onChangeOrder () {
      this.$emit('order', this.filters.orderBy)
    },
    clearFilter () {
      this.filters.whereIn.unit_of_measurement = []
    },
    applyFilters () {
      this.$emit('filter', this.filters.whereIn.unit_of_measurement)
    },
    hasId (column) {
      return (column === 'id' && this.id) || column !== 'id'
    },
    setColor (row) {
      return row.status === 'Autorizada' ? 'success' : '#D65252'
    }
  }
}
</script>

<style lang="scss">
.table_design {
  background-color: WHITE;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.05);
  border-radius: 30px;
  padding: 1.5em;
}

.table_dashboard_container {
  width: 98.5%;
}

.vm-table--header {
  display: flex;
  align-items: center;
  justify-content: left;
  flex-direction: row;
  span {
    width: 100%;
  }
}

.status {
  position: relative;
  left: 0.8rem;

  .vm-status-indicator--text {
    display: none;
  }
}

.text-center {
  min-width: 100%;
  text-align: center;
}

.row {
  span {
    width: 100%;
    flex: 1;
  }
}

.header {
  background-color: RED;
}

.orderBy {
  width: 50%;
  flex: 0.25;
}

.filters {
    gap: 10px;
    padding: 0.5rem;
}

</style>
